export function getContentHeight() {
    const xcloudContentDiv = document.getElementById("xcloud-content");
    if (xcloudContentDiv != null) {
        return xcloudContentDiv.clientHeight;
    } else {
        return window.innerHeight;
    }
}